import React from 'react';
import { useNavigate } from 'react-router';

import { useAppConfigContext } from '../../hooks/useAppConfigContext';

import styles from './Logo.module.css';

export const Logo = () => {
  const navigate = useNavigate();
  const config = useAppConfigContext();

  const handleClick = () => {
    navigate('/');
  };

  return (
    <button className={styles.logo} onClick={handleClick} type="button">
      <p className={styles.textLarge}>
        <span className="tracking-wider text-white align-bottom font-specialGothic font-normal">
          {config.logo}
        </span>
      </p>
      <p className={styles.extraText}>{config.logoExtraText}</p>
    </button>
  );
};
